var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDamaged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1200.000000pt",
    height: "1200.000000pt",
    viewBox: "0 0 1200.000000 1200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1200.000000) scale(0.100000,-0.100000)",
    fill: "#ceb081",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5705 11994 c-249 -18 -355 -29 -513 -50 -900 -121 -1764 -448 -2523 -955 -1431 -955 -2386 -2483 -2613 -4181 -43 -317 -51 -446 -51 -808 0 -448 30 -762 110 -1165 456 -2293 2193 -4108 4466 -4664 484 -118 887 -165 1419 -165 336 0 480 8 735 40 1182 148 2265 628 3181 1409 166 140 489 463 629 629 781 915 1261 1999 1409 3181 32 255 40 399 40 735 0 499 -38 858 -140 1315 -518 2312 -2360 4108 -4687 4570 -383 76 -674 105 -1092 109 -176 2 -342 2 -370 0z m485 -1381 c257 -62 476 -253 570 -495 64 -165 61 1 58 -2798 l-3 -2545 -28 -88 c-50 -159 -119 -271 -235 -378 -160 -147 -331 -213 -552 -213 -221 0 -392 66 -552 213 -116 107 -185 219 -235 378 l-28 88 0 2585 0 2585 22 77 c43 148 101 252 201 360 57 62 185 152 264 186 160 70 349 86 518 45z m30 -7643 c118 -34 242 -104 333 -189 120 -114 185 -219 233 -378 36 -119 38 -306 5 -428 -78 -288 -301 -510 -591 -586 -65 -17 -113 -22 -200 -22 -177 0 -306 39 -456 139 -191 126 -312 318 -351 556 -71 432 231 847 675 928 78 15 268 4 352 -20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDamaged);
export default __webpack_public_path__ + "static/media/damaged.932e72f9d5006e1f27f8744087e872f8.svg";
export { ForwardRef as ReactComponent };